// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8b6ecd33","453":"ec54f5fc","455":"7aa6447d"}[chunkId] + ".chunk.js";
};